/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GetMessage1QueryResponse, GetMessage1PathParams, GetMessage1400, GetMessage1401, GetMessage1403, GetMessage1404, GetMessage1409, GetMessage1500 } from "../../types/GetMessage1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getGetMessage1Url(messageId: GetMessage1PathParams["messageId"]) {
  const res = { method: 'GET', url: `/api/research-chat/message/${messageId}` as const }
  return res
}

/**
 * @description Retrieves the complete message including AI response and web citations. Only available after status is FINISHED.
 * @summary Get full message with content and citations
 * {@link /api/research-chat/message/:messageId}
 */
export async function getMessage1(messageId: GetMessage1PathParams["messageId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetMessage1QueryResponse, ResponseErrorConfig<GetMessage1400 | GetMessage1401 | GetMessage1403 | GetMessage1404 | GetMessage1409 | GetMessage1500>, unknown>({ method : "GET", url : getGetMessage1Url(messageId).url.toString(), ... requestConfig })
  return res.data
}